import Footer from "@components/Footer/Footer";
import NavbarCustom from "@components/NavbarCustom/NavbarCustom";
import LoginContent from "@containers/LoginContainer/LoginContent";
import React, { useState } from "react";

function LogInScreen() {
	const [notificationsOpen, setNotificationsOpen] = useState<boolean>(false);

	return (
		<div style={{ overflow: "hidden", minHeight: "100%" }}>
			<LoginContent />
		</div>
	);
}

export default LogInScreen;
